// extracted by mini-css-extract-plugin
var _1 = "NoItemsCTA_container__cNDYB";
var _2 = "NoItemsCTA_cta__NjLwf";
var _3 = "NoItemsCTA_icon__b075S fal fa-shopping-bag";
var _4 = "NoItemsCTA_mobile__J1Os1";
var _5 = "NoItemsCTA_title__3Ypob";
export { _1 as "container", _2 as "cta", _3 as "icon", _4 as "mobile", _5 as "title" }
